import jsonExport from "jsonexport/dist";
import moment from "moment";
import * as React from "react";
import { Datagrid, Filter, List, TextField, TextInput, downloadCSV } from "react-admin";
import AuthorizedCheck from "../../components/Authorized/AuthorizedCheck";

const PostFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Name" source="name__contains" alwaysOn />
  </Filter>
);

const CategoryListTitle = () => {
  return <span>Category List</span>;
};

const exporter = (categories: any[]) => {
  const categoriesForExport = categories.map((category) => {
    return {
      Name: category.name,
    };
  });

  jsonExport(categoriesForExport, { rowDelimiter: ";" }, (err: any, csv: any) => {
    if (err) return console.log(err);

    //UTF8
    const bom = "\uFEFF";
    downloadCSV(`${bom} ${csv}`, `CategoryList-${moment().format("yyyMMDDHHmmss")}`);
  });
};

const CategoryList = (props) => {
  return (
    <AuthorizedCheck>
      <List {...props} filters={<PostFilter />} title={<CategoryListTitle />} exporter={exporter}>
        <Datagrid rowClick="edit">
          <TextField source="name" />
        </Datagrid>
      </List>
    </AuthorizedCheck>
  );
};

export default CategoryList;
